import React, {useCallback, useState} from 'react';


import {SlideBoxComponent} from 'src/components/slide-box';

import {LocalStorage} from '@pb/kit-util-client-storage';

import {AdditionalAdminTools} from './additional-admin-tools';
import {RecentlyViewedAccounts} from './recently-viewed-accounts';
import {RecentlyViewedUsers} from './recently-viewed-users';

import {recentlyViewedSectionContainer} from './recently-viewed-section.module.styl';

export const RecentlyViewedSection = () => {
    const [activeSlide, setActiveSlide] = useState(
        LocalStorage.get('recently-viewed-section') || 'accounts',
    );

    const updateSection = useCallback((section: string) => {
        LocalStorage.set('recently-viewed-section', section);
        setActiveSlide(section);
    }, []);

    return (
        <div className={recentlyViewedSectionContainer}>
            <SlideBoxComponent
                caption="Recently viewed accounts"
                isExpanded={activeSlide === 'accounts'}
                onToggle={isExpanded => updateSection(isExpanded ? 'accounts' : '')}>
                <RecentlyViewedAccounts/>
            </SlideBoxComponent>
            <SlideBoxComponent
                caption="Recently viewed users"
                isExpanded={activeSlide === 'users'}
                onToggle={isExpanded => updateSection(isExpanded ? 'users' : '')}>
                <RecentlyViewedUsers/>
            </SlideBoxComponent>
            <SlideBoxComponent
                caption="Additional Admin Tools"
                isExpanded={activeSlide === 'tools'}
                onToggle={isExpanded => updateSection(isExpanded ? 'tools' : '')}>
                <AdditionalAdminTools/>
            </SlideBoxComponent>
        </div>
    );
};
